import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import WorkerStatus from '@/views/MapControl/WorkerWrapper/WorkerStatus.vue';
import Search from '@/views/MapControl/Common/Search.vue';
import WorkerList from '@/views/MapControl/WorkerWrapper/WorkerList.vue';
import vuexStore from '@/vuex-store';
import { computed } from 'vue';
import { listControlGetterType } from '@/vuex-store/list-control/getters';
import { listControlActionType } from '@/vuex-store/list-control/actions';
const lc = 'views.map_control.worker_wrapper.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkerWrapper',
    setup(__props) {
        const sortBy = computed(() => vuexStore.state.listControl.workerSortBy);
        const onSortAction = (value) => {
            vuexStore.dispatch(listControlActionType.setWorkerSortBy, value);
        };
        const onSearch = (query) => {
            vuexStore.dispatch(listControlActionType.inputSearchWorkerQuery, query);
        };
        const getterMainWorkerList = computed(() => vuexStore.getters[listControlGetterType.getterMainWorkerList]);
        const selectedWorkerFilter = computed(() => vuexStore.state.listControl.selectedWorkerFilter);
        const workerTotal = computed(() => vuexStore.state.listControl.workerTotal);
        const onClickWorkerFilter = (filterId = 'ALL') => {
            vuexStore.dispatch(listControlActionType.setWorkerFilter, filterId);
        };
        /**
         * handler 워커 클릭 핸들러
         * @param workerData 워커 데이터
         */
        const handleClickWorkerItem = async (workerData) => {
            const prevWorkerCode = vuexStore.state.listControl.selectedWorker?.code;
            const newWorkerCode = workerData.code;
            // 지도관제쪽 로직
            window.popupMapControl?.selectWorker(newWorkerCode);
            await vuexStore.dispatch(listControlActionType.setSelectedWorker);
            // 재클릭
            if (newWorkerCode === prevWorkerCode) {
                return;
            }
            // 고도화시 추가
            // vuexStore.dispatch(listControlActionType.addSelectedWorkerOrder, workerData);
            vuexStore.dispatch(listControlActionType.setSelectedWorker, workerData);
        };
        /**
         * 선택된 워커 여부
         */
        const isSelectedWorker = (code) => (code === vuexStore.state.listControl.selectedWorker?.code);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createCommentVNode(" 라이더 현황 "),
                _createVNode(WorkerStatus, {
                    "selected-worker-filter": selectedWorkerFilter.value,
                    "worker-total": workerTotal.value,
                    "on-click-worker-filter": onClickWorkerFilter
                }, null, 8 /* PROPS */, ["selected-worker-filter", "worker-total"]),
                _createCommentVNode(" 검색 "),
                _createVNode(Search, {
                    placeholder: _ctx.$t(lc + 'search_placeholder'),
                    "on-search": onSearch
                }, null, 8 /* PROPS */, ["placeholder"]),
                _createCommentVNode(" 라이더 리스트 "),
                _createVNode(WorkerList, {
                    class: "root-worker-list",
                    "main-worker-list": getterMainWorkerList.value,
                    "on-click-worker-item": handleClickWorkerItem,
                    "is-selected": isSelectedWorker,
                    "sort-by": sortBy.value,
                    "on-sort-action": onSortAction,
                    "is-sort": ""
                }, null, 8 /* PROPS */, ["main-worker-list", "sort-by"])
            ]));
        };
    }
});
